// GOAT Connect focus guard (#15710).
//
// Bootstrap 5's FocusTrap (every HAML gl_modal, every gl_modal_shell, the
// Offcanvas) binds a `focusin` listener on the DOCUMENT each time a modal is
// shown, and refocuses the modal whenever focus lands outside it. During a
// call the dialer paints above every modal (the raised tier in
// _goat_connect_softphone.scss), so the agent clicks into its call note,
// transfer search or dial field — and the trap yanked focus straight back
// into the modal, so nothing could be typed.
//
// This guard is registered on the document at boot, BEFORE any modal can be
// shown, so it runs first among the document's bubble-phase listeners. For a
// target inside a GOAT Connect surface it calls stopImmediatePropagation(),
// which skips the later document listeners (the traps) and the window. It
// cannot touch anything nearer the target: React's own focus handlers live on
// the softphone's root / portal containers, and capture-phase listeners
// (tooltip_edge_align.js) have already run. Focus anywhere else on the page
// passes through untouched, so every modal keeps its trap.
//
// The surfaces opt in with one attribute: the turbo-permanent mount
// (shared/_goat_connect_softphone.html.haml) and the phone shell React
// portals to <body> (SoftphoneMobileShell).
export const SOFTPHONE_SURFACE_SELECTOR = "[data-gl-softphone-surface]"

const installed = new WeakSet()

export function isSoftphoneSurface(target) {
  return target instanceof Element && target.closest(SOFTPHONE_SURFACE_SELECTOR) !== null
}

export function installSoftphoneFocusGuard(doc = document) {
  if (installed.has(doc)) return () => {}

  const guard = (event) => {
    if (isSoftphoneSurface(event.target)) event.stopImmediatePropagation()
  }
  doc.addEventListener("focusin", guard)
  installed.add(doc)

  let active = true
  return () => {
    if (!active) return
    active = false
    doc.removeEventListener("focusin", guard)
    installed.delete(doc)
  }
}
